/**
 * 专家评审团成员数据
 * 后期将从后端接口获取
 */

export const membersData = {
  zh: [
    {
      id: 1,
      group: 'founder',
      name: '梁建章',
      role: '发起人及荣誉顾问',
      titles: [
        '携程集团董事局主席、创生基金创始人',
      ],
      bio: '梁建章博士于1999年联合创立携程集团，主导企业完成从传统呼叫中心到线上平台，再至移动互联网生态的重要转型。通过战略投资与业务孵化，推动携程发展成为覆盖全球的一站式旅游服务供应商。此外，他还担任其他上市公司的董事会成员。\n\n在人口和社会、创业创新领域，梁建章博士做出了全社会有目共睹的研究努力。他通过多种方式，向公共层面传播国家、社会、企业、个人创新力的关系与价值：出版了《中国人太多了吗？》（2012）、《人口创新力》（2018）、《人口战略》（2023）、《创新主义》（2024）等著作，提出「人口规模和结构决定国家创新力」核心理论，2020年创作人口寓言小说《永生之后》，并将其改编为沉浸式影音剧。\n\n2021年他联合创办了「育娲人口研究」，发布《中国生育成本报告》《中国人口预测报告》等系列研究，警示少子化与老龄化问题；该机构于2024年扩展为「育娲人口智库」。\n\n在企业创新实践方面，梁建章博士深入研究「混合办公」模式，在《Nature》《The Quarterly Journal of Economics》等期刊发表论文，并于2022年在携程全面实践该模式。同时，他致力于将携程集团打造为全球领先的家庭友好型企业，先后推出「5万元生育礼金」、「辅助生育补贴」以及「陪娃假期」等创新型福利项目。\n\n近年来，梁建章博士持续研究创新理论体系，在2024年出版的《创新主义》中将创新提升至哲学维度，首提「创新与传承」的创新价值体系，强调创新力对生命意义的深刻影响。',
      image: '/image/members/james-liang.png',
    },
    {
      id: 2,
      group: 'honoraryAdvisor',
      name: '黄文政',
      role: '荣誉顾问',
      titles: ['育娲人口智库执行长，首席研究员'],
      bio: '黄文政博士是育娲人口智库执行长兼首席研究员，中国与全球化中心特邀高级研究员。获约翰斯·霍普金斯大学生物统计学博士，曾任哈佛大学助理教授及国际金融机构高管。长期研究人口与生育问题，与梁建章合著多部著作及200余篇文章，聚焦人口趋势、经济发展与生育政策。其研究成果和观点广受关注，曾受邀在学术、政商界分享，并接受《华尔街日报》、BBC等国际主流媒体采访。',
      image: '/image/members/wenzheng-huang.png',
    },
    {
      id: 3,
      group: 'academicCommittee',
      role: '学术委员会',
      name: 'Emma Zang',
      titles: ['耶鲁大学社会学系长聘副教授，并兼任生物统计学与全球事务双聘职务'],
      bio: 'Emma Zang 教授现任耶鲁大学社会学系长聘副教授，并兼任生物统计学与全球事务双聘职务。她的研究聚焦家庭人口学、健康与老龄化、家庭政策与性别不平等的交叉领域，尤其关注灵活工作安排、婚姻法律等家庭政策如何影响生育、性别平等与家庭福祉。她在中美比较研究及定量方法方面具有突出贡献，研究成果广泛发表于顶尖学术期刊。',
      image: '/image/members/emma-zang.png',
    },
    {
      id: 4,
      group: 'academicCommittee',
      role: '学术委员会',
      name: '於嘉',
      titles: ['北京大学光华管理学院社会研究中心长聘副教授、博士生导师'],
      bio: '於嘉教授现任北京大学光华管理学院社会研究中心长聘副教授、博士生导师。她的主要研究领域为婚姻与家庭、人口转变、性别不平等与社会分层。近年重点关注中国低生育率现象、理想子女数量的宏观影响因素，以及生育对女性职业发展与工资的影响，研究成果发表于国内外权威期刊，具有重要的学术与政策影响力。',
      image: '/image/members/jia-yu.png',
    },
    {
      id: 5,
      group: 'industryCommittee',
      role: '业界委员会',
      name: '张祺',
      nameEn: 'Qi Zhang',
      titles: ['杰出雇主调研机构（Top Employers Institute）北亚区负责人'],
      bio: '张祺先生现任杰出雇主调研机构（Top Employers Institute）北亚区负责人，拥有 18 年跨国企业商业与战略领导经验。长期专注精益转型、市场洞察与战略落地实践，深耕未来职场、人才战略与组织体系建设领域。依托机构标准化认证体系与数据驱动方法论，围绕领导力发展、多元包容、可持续劳动力管理开展研究与项目实践，持续与企业管理层协同优化人才管理体系，助力组织提升人才保留、员工敬业度与长期组织韧性，相关实践为企业人力资源战略升级提供标杆参考。',
      image: '/image/members/qi-zhang.png',
    },
    {
      id: 6,
      group: 'industryCommittee',
      role: '业界委员会',
      name: '唐秋勇',
      nameEn: 'Anson Tang',
      titles: [
        '法国里昂商学院（Emlyon）全球人力资源与组织研究中心主任',
        'HRflag执行董事',
      ],
      bio: '唐秋勇博士在人力资源管理、信息技术领域有20多年创业、经营管理、研究经验。拥有法国蒙彼利埃大学（Université de Montpellier）管理学博士学位和澳大利亚国立大学（The Australian National University）创新管理硕士学位，以及华中科技大学（HUST）工商管理硕士学位。他曾为中国最大的人力资源媒体公司创始人和总经理，并曾任《人力资本管理》月刊（国内刊号：CN31-2102/F）杂志创刊人和主编。他著有20多本人工智能和人力资源管理方面的畅销图书以及2本画集，他撰写的《HR的未来简史》、《HR的未来使命》、《HR的未来思维》并称为"HR的未来三部曲"，并多次位居亚马逊（Amazon）人力资源类新书榜第一。2024年以来他完成了6本关键人工智能教材图书-《提示词工程学》（Prompt Engineering）、《氛围编程》（Vibe Coding）、《涌现-在混沌与秩序之间的智能》（Emergence）、《AI组织学》（AI Organizational Dynamics）、《人工智能经济学》（Tokenomics）、《人工智能伦理、安全与隐私》（Ethics, Security, And Privacy in AI）。',
      image: '/image/members/qiuyong-tang.png',
    },
    {
      id: 7,
      group: 'industryCommittee',
      role: '业界委员会',
      name: '傅海洋',
      nameEn: 'Ocean Fu',
      titles: ['中国雇主品牌领域先行者、纬思文化（Wild Theory）创始人、雇主品牌研究所发起人'],
      bio: '傅海洋女士（Ocean Fu）是中国雇主品牌领域先行者、纬思文化（Wild Theory）创始人，同时也是雇主品牌研究所发起人。作为中国较早将雇主品牌理念引入企业实践的推动者之一，她于2010年起探索将营销思维与人才管理相结合，推动企业从传统招聘传播走向系统化雇主品牌建设。\n\n她曾任职于多家国内外知名企业，深耕品牌战略、市场创新与创意传播领域逾二十年，具备丰富的品牌建设经验。基于对品牌、组织文化与人才竞争的长期洞察，她致力于帮助企业构建差异化的雇主价值体系，将企业文化、人才战略与品牌传播有效连接。她创立的纬思文化（Wild Theory）长期专注于雇主品牌战略、EVP构建与人才传播体系实践，服务多个行业的头部企业与成长型企业逾300家，覆盖奢侈品、汽车、消费品、医药健康、科技制造及新能源等领域。她创立了中国首个以项目实践为核心的雇主品牌专业赛事——雇主品牌创意大赛（Employer Branding Creativity Awards），持续推动行业优秀实践交流与生态建设。同时，她多次受邀担任国际雇主品牌奖项评审，并通过行业研究、专业课程与交流平台，推动中国雇主品牌领域的发展与创新。',
      image: '/image/members/ocean-fu.png',
    },
    {
      id: 8,
      group: 'industryCommittee',
      role: '业界委员会',
      name: '王玥清',
      nameEn: 'Renee Wang',
      titles: ['LinkedIn（领英）中国区人才解决方案客户成功负责人'],
      bio: '王玥清女士现任LinkedIn（领英）中国区人才解决方案客户成功负责人，长期专注于人才战略、组织变革、组织文化建设、雇主品牌及企业全球化发展。她长期与中国领先企业合作，帮助企业应对人才市场变革与全球化带来的挑战，通过优化人才战略、提升组织能力、推动跨文化协作以及塑造面向未来的组织文化，不断增强企业的人才竞争力与组织韧性。依托领英全球人才洞察与数据能力，她持续为企业管理者提供关于人才趋势、技能转型、领导力发展和组织变革的战略建议与实践经验，助力企业打造高绩效组织，实现可持续增长。',
      image: '/image/members/renee-wang.jpg',
    },
  ],

  zh_TW: [
    {
      id: 1,
      group: 'founder',
      name: '梁建章',
      role: '發起人及榮譽顧問',
      titles: [
        '攜程集團董事局主席、創生基金創始人',
      ],
      bio: '梁建章博士於1999年聯合創立攜程集團，主導企業完成從傳統呼叫中心到線上平台，再至移動互聯網生態的重要轉型。通過戰略投資與業務孵化，推動攜程發展成為覆蓋全球的一站式旅遊服務供應商。此外，他還擔任其他上市公司的董事會成員。\n\n在人口和社會、創業創新領域，梁建章博士做出了全社會有目共睹的研究努力。他通過多種方式，向公共層面傳播國家、社會、企業、個人創新力的關係與價值：出版了《中國人太多了嗎？》（2012）、《人口創新力》（2018）、《人口戰略》（2023）、《創新主義》（2024）等著作，提出「人口規模和結構決定國家創新力」核心理論，2020年創作人口寓言小說《永生之後》，並將其改編為沉浸式影音劇。\n\n2021年他聯合創辦了「育媧人口研究」，發布《中國生育成本報告》《中國人口預測報告》等系列研究，警示少子化與老齡化問題；該機構於2024年擴展為「育媧人口智庫」。\n\n在企業創新實踐方面，梁建章博士深入研究「混合辦公」模式，在《Nature》《The Quarterly Journal of Economics》等期刊發表論文，並於2022年在攜程全面實踐該模式。同時，他致力於將攜程集團打造為全球領先的家庭友好型企業，先後推出「5萬元生育禮金」、「輔助生育補貼」以及「陪娃假期」等創新型福利項目。\n\n近年來，梁建章博士持續研究創新理論體系，在2024年出版的《創新主義》中將創新提升至哲學維度，首提「創新與傳承」的創新價值體系，強調創新力對生命意義的深刻影響。',
      image: '/image/members/james-liang.png',
    },
    {
      id: 2,
      group: 'honoraryAdvisor',
      name: '黃文政',
      role: '榮譽顧問',
      titles: ['育媧人口智庫執行長，首席研究員'],
      bio: '黃文政博士是育媧人口智庫執行長兼首席研究員，中國與全球化中心特邀高級研究員。獲約翰斯·霍普金斯大學生物統計學博士，曾任哈佛大學助理教授及國際金融機構高管。長期研究人口與生育問題，與梁建章合著多部著作及200餘篇文章，聚焦人口趨勢、經濟發展與生育政策。其研究成果和觀點廣受關注，曾受邀在學術、政商界分享，並接受《華爾街日報》、BBC等國際主流媒體採訪。',
      image: '/image/members/wenzheng-huang.png',
    },
    {
      id: 3,
      group: 'academicCommittee',
      role: '學術委員會',
      name: 'Emma Zang',
      titles: ['耶魯大學社會學系長聘副教授，並兼任生物統計學與全球事務雙聘職務'],
      bio: 'Emma Zang 教授現任耶魯大學社會學系長聘副教授，並兼任生物統計學與全球事務雙聘職務。她的研究聚焦家庭人口學、健康與老齡化、家庭政策與性別不平等的交叉領域，尤其關注靈活工作安排、婚姻法律等家庭政策如何影響生育、性別平等與家庭福祉。她在中美比較研究及定量方法方面具有突出貢獻，研究成果廣泛發表於頂尖學術期刊。',
      image: '/image/members/emma-zang.png',
    },
    {
      id: 4,
      group: 'academicCommittee',
      role: '學術委員會',
      name: '於嘉',
      titles: ['北京大學光華管理學院社會研究中心長聘副教授、博士生導師'],
      bio: '於嘉教授現任北京大學光華管理學院社會研究中心長聘副教授、博士生導師。她的主要研究領域為婚姻與家庭、人口轉變、性別不平等與社會分層。近年重點關注中國低生育率現象、理想子女數量的宏觀影響因素，以及生育對女性職業發展與工資的影響，研究成果發表於國內外權威期刊，具有重要的學術與政策影響力。',
      image: '/image/members/jia-yu.png',
    },
    {
      id: 5,
      group: 'industryCommittee',
      role: '業界委員會',
      name: '張祺',
      nameEn: 'Qi Zhang',
      titles: ['傑出僱主調研機構（Top Employers Institute）北亞區負責人'],
      bio: '張祺先生現任傑出僱主調研機構（Top Employers Institute）北亞區負責人，擁有 18 年跨國企業商業與戰略領導經驗。長期專注精益轉型、市場洞察與戰略落地實踐，深耕未來職場、人才戰略與組織體系建設領域。依託機構標準化認證體系與數據驅動方法論，圍繞領導力發展、多元包容、可持續勞動力管理開展研究與項目實踐，持續與企業管理層協同優化人才管理體系，助力組織提升人才保留、員工敬業度與長期組織韌性，相關實踐為企業人力資源戰略升級提供標杆參考。',
      image: '/image/members/qi-zhang.png',
    },
    {
      id: 6,
      group: 'industryCommittee',
      role: '業界委員會',
      name: '唐秋勇',
      nameEn: 'Anson Tang',
      titles: [
        '法國里昂商學院（Emlyon）全球人力資源與組織研究中心主任',
        'HRflag執行董事',
      ],
      bio: '唐秋勇博士在人力資源管理、信息技術領域有20多年創業、經營管理、研究經驗。擁有法國蒙彼利埃大學（Université de Montpellier）管理學博士學位和澳大利亞國立大學（The Australian National University）創新管理碩士學位，以及華中科技大學（HUST）工商管理碩士學位。他曾為中國最大的人力資源媒體公司創始人和總經理，並曾任《人力資本管理》月刊（國內刊號：CN31-2102/F）雜誌創刊人和主編。他著有20多本人工智能和人力資源管理方面的暢銷圖書以及2本畫集，他撰寫的《HR的未來簡史》、《HR的未來使命》、《HR的未來思維》並稱為「HR的未來三部曲」，並多次位居亞馬遜（Amazon）人力資源類新書榜第一。2024年以來他完成了6本關鍵人工智能教材圖書-《提示詞工程學》（Prompt Engineering）、《氛圍編程》（Vibe Coding）、《涌現-在混沌與秩序之間的智能》（Emergence）、《AI組織學》（AI Organizational Dynamics）、《人工智能經濟學》（Tokenomics）、《人工智能倫理、安全與隱私》（Ethics, Security, And Privacy in AI）。',
      image: '/image/members/qiuyong-tang.png',
    },
    {
      id: 7,
      group: 'industryCommittee',
      role: '業界委員會',
      name: '傅海洋',
      nameEn: 'Ocean Fu',
      titles: ['中國僱主品牌領域先行者、緯思文化（Wild Theory）創始人、僱主品牌研究所發起人'],
      bio: '傅海洋女士（Ocean Fu）是中國僱主品牌領域先行者、緯思文化（Wild Theory）創始人，同時也是僱主品牌研究所發起人。作為中國較早將僱主品牌理念引入企業實踐的推動者之一，她於2010年起探索將營銷思維與人才管理相結合，推動企業從傳統招聘傳播走向系統化僱主品牌建設。\n\n她曾任職於多家國內外知名企業，深耕品牌戰略、市場創新與創意傳播領域逾二十年，具備豐富的品牌建設經驗。基於對品牌、組織文化與人才競爭的長期洞察，她致力於幫助企業構建差異化的僱主價值體系，將企業文化、人才戰略與品牌傳播有效連接。她創立的緯思文化（Wild Theory）長期專注於僱主品牌戰略、EVP構建與人才傳播體系實踐，服務多個行業的頭部企業與成長型企業逾300家，覆蓋奢侈品、汽車、消費品、醫藥健康、科技製造及新能源等領域。她創立了中國首個以項目實踐為核心的僱主品牌專業賽事——僱主品牌創意大賽（Employer Branding Creativity Awards），持續推動行業優秀實踐交流與生態建設。同時，她多次受邀擔任國際僱主品牌獎項評審，並通過行業研究、專業課程與交流平台，推動中國僱主品牌領域的發展與創新。',
      image: '/image/members/ocean-fu.png',
    },
    {
      id: 8,
      group: 'industryCommittee',
      role: '業界委員會',
      name: '王玥清',
      nameEn: 'Renee Wang',
      titles: ['LinkedIn（領英）中國區人才解決方案客戶成功負責人'],
      bio: '王玥清女士現任LinkedIn（領英）中國區人才解決方案客戶成功負責人，長期專注於人才戰略、組織變革、組織文化建設、僱主品牌及企業全球化發展。她長期與中國領先企業合作，幫助企業應對人才市場變革與全球化帶來的挑戰，通過優化人才戰略、提升組織能力、推動跨文化協作以及塑造面向未來的組織文化，不斷增強企業的人才競爭力與組織韌性。依託領英全球人才洞察與數據能力，她持續為企業管理者提供關於人才趨勢、技能轉型、領導力發展和組織變革的戰略建議與實踐經驗，助力企業打造高績效組織，實現可持續增長。',
      image: '/image/members/renee-wang.jpg',
    },
  ],

  en: [
    {
      id: 1,
      group: 'founder',
      name: 'James Liang',
      role: 'Founder & Honorary Advisor',
      titles: [
        'Chairman of the Board of Trip.com Group Limited',
        'Founder of Genovation Foundation',
      ],
      bio: "Dr. James Liang co-founded Trip.com Group in 1999 and has led the company's transformation from a traditional call center to an online platform, and later into a mobile internet ecosystem. Through strategic investments and business incubation, he has helped Trip.com Group grow into a leading one-stop travel services provider with a global presence. He also serves on the boards of several other listed companies.\n\nDr. Liang is widely recognized for his influential research on China's demographics, society, entrepreneurship, and innovation, engaging in public advocacy about the value of innovation for nations, societies, enterprises, and individuals. His works include Too Many People in China? (2012), The Demographics of Innovation (2018), Population Strategies (2023), Innovation, Heritage, and Meaning of Life (2024), in which he proposed the core theory that \"a nation's population size and structure underlie its innovation capacity.\" He also authored in 2020 the allegorical novel After Immortality, which was adapted into an immersive play.\n\nIn 2021 he co-founded the Yuwa Population Research, which has published reports such as the China Fertility Cost Report and China Population Forecast Report to raise awareness of low fertility and aging challenges. This organization was later expanded into Yuwa Population Institute.\n\nIn corporate innovation, Dr. Liang has conducted in-depth research on hybrid work models, with findings published in leading journals such as Nature and The Quarterly Journal of Economics. In 2022, he led Trip.com Group's full implementation of a hybrid work policy. He has also championed the company's development into a global leader in family-friendly workplaces, introducing pioneering benefits such as the \"RMB 50,000 Childcare Subsidies,\" fertility assistance subsidies, and dedicated parental leave.\n\nIn recent years, Dr. Liang has continued to advance innovation theory. In his latest work, Innovation, Heritage, and Meaning of Life (2024), he elevates innovation to a philosophical dimension, introducing the \"Innovation and Heritage\" value system while emphasizing the profound impact of innovation on the meaning of life.",
      image: '/image/members/james-liang.png',
    },
    {
      id: 2,
      group: 'honoraryAdvisor',
      name: 'Wenzheng Huang',
      role: 'Honorary Advisor',
      titles: ['Executive Director & Chief Researcher of Yuwa Population Institute'],
      bio: 'Dr. Wenzheng Huang is the Executive Director and Chief Researcher of the Yuwa Population Institute and an Invited Senior Researcher at the Center for China and Globalization (CCG). He holds a Ph.D. in Biostatistics from Johns Hopkins University and previously served as an Assistant Professor at Harvard University and held senior leadership positions in the international financial industry. His research focuses on demographics, fertility, economic development, and population policy. He has co-authored several books and over 200 articles with Dr. James Liang. His work has been widely recognized, and he has been invited to speak at academic, government, and business forums, as well as interviewed by leading international media, including The Wall Street Journal and the BBC.',
      image: '/image/members/wenzheng-huang.png',
    },
    {
      id: 3,
      group: 'academicCommittee',
      role: 'Academic Committee',
      name: 'Emma Zang',
      titles: [
        'Tenured Associate Professor in the Department of Sociology at Yale University, with joint appointments in Biostatistics and Global Affairs',
      ],
      bio: 'Professor Emma Zang is a tenured Associate Professor in the Department of Sociology at Yale University, with joint appointments in Biostatistics and Global Affairs. Her research focuses on the intersection of family demography, health and aging, family policy, and gender inequality—with particular attention to how family policies such as flexible work arrangements and marriage legislation shape fertility, gender equality, and family well-being. She has made notable contributions to China–U.S. comparative research and quantitative methodology, and her work has been widely published in leading academic journals.',
      image: '/image/members/emma-zang.png',
    },
    {
      id: 4,
      group: 'academicCommittee',
      role: 'Academic Committee',
      name: 'Jia Yu',
      titles: [
        'Tenured Associate Professor and doctoral supervisor at the Center for Social Research, Guanghua School of Management, Peking University',
      ],
      bio: "Professor Jia Yu is a tenured Associate Professor and doctoral supervisor at the Center for Social Research, Guanghua School of Management, Peking University. Her primary research areas include marriage and family, demographic transition, gender inequality, and social stratification. In recent years, her work has focused on China's low fertility phenomenon, macro-level determinants of ideal family size, and the impact of childbearing on women's career development and wages. Her research has been published in leading domestic and international journals, with significant academic and policy influence.",
      image: '/image/members/jia-yu.png',
    },
    {
      id: 5,
      group: 'industryCommittee',
      role: 'Industry Committee',
      name: 'Qi Zhang',
      titles: ['Regional head of North Asia at Top Employers Institute (TEI)'],
      bio: 'Mr. Qi Zhang is the regional head of North Asia at Top Employers Institute (TEI). With over 18 years of leadership experience in multinational corporations, he specializes in business strategy, organizational transformation, and talent strategy. His work focuses on the future of work, leadership development, DEI, and sustainable workforce management. Leveraging standardized assessment frameworks and data-driven methodologies, he partners with senior executives to enhance talent management, improve employee engagement and retention, and build resilient organizations, helping companies advance their long-term HR strategies.',
      image: '/image/members/qi-zhang.png',
    },
    {
      id: 6,
      group: 'industryCommittee',
      role: 'Industry Committee',
      name: 'Anson Tang',
      titles: [
        'Director of Global Human Resources & Organization Innovation Center, emlyon business school (France)',
        'HRflag Executive Director',
      ],
      bio: "Dr. Anson Tang is the director of Global Human Resources & Organization Innovation Center, emlyon business school (France), and HRflag Executive Director. With over 20 years of entrepreneurial, operational management, and research experience in human resource management and information technology. He holds a PhD in Management from the Université de Montpellier (University of Montpellier, France), a Master's degree in Innovation Management from The Australian National University (ANU), and an MBA from Huazhong University of Science and Technology (HUST).\n\nHe previously served as the founder and general manager of China's largest human resources media company, and was also the founding editor-in-chief of Human Capital Management magazine.\n\nHe is the author of over 20 bestselling books on artificial intelligence and human resource management, as well as two art albums. His works \"A Brief History of the Future of HR\", \"The Future Mission of HR\", and \"The Future Mindset of HR\" are collectively known as the \"Future of HR Trilogy,\" and have repeatedly ranked No. 1 on Amazon's new releases list in the HR category. Since 2024, he has completed six key AI textbook titles: \"Prompt Engineering\", \"Vibe Coding\", \"Emergence: Intelligence Between Chaos and Order\", \"AI Organizational Dynamics\", \"Tokenomics\", and \"Ethics, Security, and Privacy in AI\".",
      image: '/image/members/qiuyong-tang.png',
    },
    {
      id: 7,
      group: 'industryCommittee',
      role: 'Industry Committee',
      name: 'Ocean Fu',
      titles: ['Employer Branding Pioneer in China, Founder of Wild Theory, Co-founder of the Employer Branding Institute'],
      bio: "Ms. Ocean Fu is a pioneer in China's employer branding industry, the Founder of Wild Theory, and the Co-founder of the Employer Branding Institute. As one of the early pioneers bringing employer branding concepts into business practices in China, Ms. Fu has been dedicated to integrating marketing thinking with talent strategy since 2010, helping organizations move from traditional recruitment communication toward strategic employer brand building.\n\nWith 20+ years of hands-on practice, Ocean has advised 300+ leading companies and Fortune 500 organizations across luxury, automotive, consumer goods, healthcare, technology, manufacturing and new energy. Her clients and project experience span some of the world's most recognized brands, helping them build EVP systems, employer brand strategies, talent communication platforms and employer reputation assets.\n\nOcean founded the Employer Branding Creativity Awards, one of China's first professional awards focused on real employer branding projects. She has also served as a judge for international employer branding awards and actively contributes to the growth of the employer branding community through research, education, and global industry exchanges.",
      image: '/image/members/ocean-fu.png',
    },
    {
      id: 8,
      group: 'industryCommittee',
      role: 'Industry Committee',
      name: 'Renee Wang',
      titles: ['Head of Customer Success at LinkedIn China Talent Solutions'],
      bio: "Mrs. Renee Wang is the head of Customer Success at LinkedIn China Talent Solutions. She specializes in talent strategy, organizational transformation, culture development, employer branding, and global growth. Partnering with China's leading enterprises, she advises business leaders on navigating workforce transformation and building future-ready organizations in an increasingly globalized business environment. Drawing on LinkedIn's unique talent insights and global labor market data, she shares strategic perspectives on talent acquisition, skills development, leadership, organizational culture, and change management, helping companies strengthen organizational resilience, unlock workforce potential, and drive sustainable business growth.",
      image: '/image/members/renee-wang.jpg',
    },
  ],
};

export const getMembersAsExperts = (lang = 'zh') => {
  return (membersData[lang] || membersData['zh']).map((m) => ({
    avatar: m.image,
    name: m.name,
    desc: m.titles.join(' / '),
    tag: m.role,
  }));
};
